/* tq-contact — auto-format the contact form's phone field to 123-456-7890.
 * Progressive enhancement: with JS off, the input's strict pattern +
 * placeholder/title still communicate and enforce the format natively. */
(function () {
  var input = document.getElementById('ContactForm-phone');
  if (!input) return;

  function fmt(v) {
    var d = v.replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    d = d.slice(0, 10);
    if (d.length > 6) return d.slice(0, 3) + '-' + d.slice(3, 6) + '-' + d.slice(6);
    if (d.length > 3) return d.slice(0, 3) + '-' + d.slice(3);
    return d;
  }

  input.addEventListener('input', function (e) {
    // Don't reformat deletions, or backspacing through a dash would re-add it.
    if (e.inputType && e.inputType.indexOf('delete') === 0) return;
    var f = fmt(input.value);
    if (f !== input.value) input.value = f;
  });

  // customer.phone prefills arrive in E.164 ("+15145551234"), which would
  // fail the strict pattern untouched.
  if (input.value) input.value = fmt(input.value);
})();
